import React from 'react'

const DeclinedDelivery = ({item,offer}) => {
    return (
        <div className='bg-[#FEF8EE] flex flex-col gap-4 w-fit rounded-xl py-4 px-4'>
            <h2 className='text-red-400 text-xl font-semibold'>Decline delivery</h2>
            <div className="bg-white flex flex-col gap-4 w-fit border-[#E9E9E9] border-2 rounded-xl p-2">
                <p className='text-sm text-gray-400'>Case offer</p>
                <p className='text-xl'>#{offer}</p>
            </div>
            <div className="bg-white flex flex-col gap-4 border-[#E9E9E9] border-2 rounded-xl p-2">
                <p>“{item}”</p>
            </div>
        </div>
    )
}

export default DeclinedDelivery